/** localStorage draft for Set B brand opinion page (/survey/set-b/brand-opinion). */
export const SET_B_LD_BRAND_OPINION_STORAGE_KEY = 'ldsurvey:setBLdBrandOpinion';

export type SetBLdFutureLikelihood = '1' | '2' | '3' | '4' | '5';

export type SetBLdBrandOpinionAnswers = {
  brandOpinion: string;
  futureLikelihood: '' | SetBLdFutureLikelihood;
  futureLikelihoodWhy: string;
};

export const emptySetBLdBrandOpinionAnswers = (): SetBLdBrandOpinionAnswers => ({
  brandOpinion: '',
  futureLikelihood: '',
  futureLikelihoodWhy: '',
});

const LIKELIHOOD_VALUES: SetBLdFutureLikelihood[] = ['1', '2', '3', '4', '5'];

export function readSetBLdBrandOpinionAnswers(): SetBLdBrandOpinionAnswers {
  try {
    const raw = localStorage.getItem(SET_B_LD_BRAND_OPINION_STORAGE_KEY);
    if (!raw) return emptySetBLdBrandOpinionAnswers();
    const parsed = JSON.parse(raw) as unknown;
    if (typeof parsed !== 'object' || parsed === null) return emptySetBLdBrandOpinionAnswers();
    const o = parsed as Record<string, unknown>;
    const likelihood =
      typeof o.futureLikelihood === 'string' &&
      LIKELIHOOD_VALUES.includes(o.futureLikelihood as SetBLdFutureLikelihood)
        ? (o.futureLikelihood as SetBLdFutureLikelihood)
        : '';
    return {
      brandOpinion: typeof o.brandOpinion === 'string' ? o.brandOpinion : '',
      futureLikelihood: likelihood,
      futureLikelihoodWhy:
        typeof o.futureLikelihoodWhy === 'string' ? o.futureLikelihoodWhy : '',
    };
  } catch {
    return emptySetBLdBrandOpinionAnswers();
  }
}

export function writeSetBLdBrandOpinionAnswers(data: SetBLdBrandOpinionAnswers): void {
  try {
    localStorage.setItem(SET_B_LD_BRAND_OPINION_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearSetBLdBrandOpinionAnswers(): void {
  try {
    localStorage.removeItem(SET_B_LD_BRAND_OPINION_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isSetBLdBrandOpinionComplete(): boolean {
  const data = readSetBLdBrandOpinionAnswers();
  return (
    data.brandOpinion.trim().length > 0 &&
    data.futureLikelihood !== '' &&
    data.futureLikelihoodWhy.trim().length > 0
  );
}

export const SET_B_LD_FUTURE_LIKELIHOOD_OPTIONS = LIKELIHOOD_VALUES;
